<template>
  <div class="orderConfirm">
    <van-nav-bar
      title="确认订单"
      left-text=""
      left-arrow
      class="main-nav"
      fixed
      @click-left="onClickLeft"
    />
    <div
      class="orderConfirm_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div
        class="myOrderDetail_content_address"
        v-if="orderDetail.isPost && !getAdreess(adreess)"
      >
        <div class="myOrderDetail_content_address_top">
          <div class="myOrderDetail_content_address_top_left">
            <img src="@/assets/images/setting/place.png" />
            <p class="myOrderDetail_content_address_top_name">
              {{ adreess.contacts }}
            </p>
            <p class="myOrderDetail_content_address_top_phone">
              {{ getDecryptBy(adreess.phone) }}
            </p>
            <div
              class="myOrderDetail_content_address_top_right"
              v-if="orderDetail.defaultFlag == 1"
            >
              默认
            </div>
          </div>
        </div>
        <div
          class="myOrderDetail_content_address_contentBox"
          @click="goAdressList"
        >
          <p class="myOrderDetail_content_address_content">
            {{ adreess.province }} {{ adreess.city }} {{ adreess.county }}
            {{ adreess.adreess }}
          </p>
          <img src="@/assets/images/setting/right.png" />
        </div>
        <img
          src="@/assets/images/setting/bottom.png"
          class="myOrderDetail_content_address_bottom"
        />
      </div>
      <div
        class="myOrderDetail_content_noAddress"
        v-if="orderDetail.isPost && getAdreess(adreess)"
        @click="goAdress(1)"
      >
        <div class="myOrderDetail_content_noAddress_cont">
          <div class="myOrderDetail_content_noAddress_cont_left">
            <img src="@/assets/images/setting/place.png" />
            <div>请填写收货地址</div>
          </div>
          <img
            src="@/assets/images/setting/right.png"
            class="myOrderDetail_content_noAddress_cont_right"
          />
        </div>
        <img
          src="@/assets/images/setting/bottom.png"
          class="myOrderDetail_content_address_bottom"
        />
      </div>
      <div class="myOrderDetail_content_bot">
        <p class="myOrderDetail_content_bot_top">订单信息</p>
        <div class="myOrderDetail_content_bot_cen">
          <img
            :src="
              orderDetail.isCourse > 0
                ? orderDetail.cover
                : orderDetail.coverMaterialUrl
            "
            class="myOrderDetail_content_bot_cen_img"
          />
          <div class="myOrderDetail_content_bot_cen_rig">
            <div class="myOrderDetail_content_bot_cen_rig_title">
              {{ orderDetail.title }}
            </div>
            <div
              class="myOrderDetail_content_bot_cen_rig_biaoqian"
              v-if="orderDetail.labels && orderDetail.labels.length > 0"
            >
              {{ orderDetail.labels[0].label }}
            </div>
          </div>
        </div>
        <div v-if="orderDetail.isPost" class="myOrderDetail_content_bot_pay">
          <p style="color: #141414 !important">赠送：</p>
          <div class="myOrderDetail_content_bot_pay_way">
            <p>配套课程资料</p>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay">
          <p>配送服务</p>
          <div class="myOrderDetail_content_bot_pay_way">
            <p>包邮</p>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay">
          <p>商品价格：</p>
          <div class="myOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              orderDetail.price &&
              orderDetail.price.toString().indexOf(".") > -1
                ? orderDetail.price.toString().split(".")[0]
                : orderDetail.price
            }}<span
              v-if="
                orderDetail.price &&
                orderDetail.price.toString().indexOf('.') > -1 &&
                orderDetail.price.toString().split('.')[1]
              "
              >.{{ orderDetail.price.toString().split(".")[1] }}</span
            >
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay">
          <p>邮费：</p>
          <div class="myOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              orderDetail.postPrice &&
              orderDetail.postPrice.toString().indexOf(".") > -1
                ? orderDetail.postPrice.toString().split(".")[0]
                : orderDetail.postPrice
            }}<span
              v-if="
                orderDetail.postPrice &&
                orderDetail.postPrice.toString().indexOf('.') > -1 &&
                orderDetail.postPrice.toString().split('.')[1]
              "
              >.{{ orderDetail.postPrice.toString().split(".")[1] }}</span
            >
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay1">
          <p>总计：</p>
          <div class="myOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              totalAmount && totalAmount.toString().indexOf(".") > -1
                ? totalAmount.toString().split(".")[0]
                : totalAmount
            }}<span
              v-if="
                totalAmount &&
                totalAmount.toString().indexOf('.') > -1 &&
                totalAmount.toString().split('.')[1]
              "
              >.{{ totalAmount.toString().split(".")[1] }}</span
            >
          </div>
        </div>
      </div>
      <div class="myOrderDetail_content_fix">
        <div class="myOrderDetail_content_fix_left">
          <p class="myOrderDetail_content_fix_left_left">总计</p>
          <p>
            <span>¥</span
            >{{
              totalAmount && totalAmount.toString().indexOf(".") > -1
                ? totalAmount.toString().split(".")[0]
                : totalAmount
            }}<span
              v-if="
                totalAmount &&
                totalAmount.toString().indexOf('.') > -1 &&
                totalAmount.toString().split('.')[1]
              "
              >.{{ totalAmount.toString().split(".")[1] }}</span
            >
          </p>
        </div>
        <div class="myOrderDetail_content_fix_right" @click="submit">
          提交订单
        </div>
      </div>
    </div>
    <dialog-common
      :infoShow="show"
      :infoMsg="infoMsg"
      :sureMsg="sureMsg"
      :cancelMsg="cancelMsg"
      @goback="close"
      @next="goAdress"
      @cance="gocance"
    ></dialog-common>
    <van-popup
      v-model="popShow"
      round
      position="bottom"
      closeable
      :style="{ height: '57%' }"
    >
      <div class="popBox">
        <div class="popBox_price">
          <span>¥</span>
          {{
            totalAmount && totalAmount.toString().indexOf(".") > -1
              ? totalAmount.toString().split(".")[0]
              : totalAmount
          }}
          <span
            v-if="
              totalAmount &&
              totalAmount.toString().indexOf('.') > -1 &&
              totalAmount.toString().split('.')[1]
            "
            >.{{ totalAmount.toString().split(".")[1] }}</span
          >
        </div>
        <div class="popBox_title">支付方式</div>
        <div class="popBox_payStyle">
          <van-radio-group v-model="radio">
            <div
              class="popBox_payStyle_wei"
              v-for="(item, index) in payTypeList"
              :key="index"
            >
              <div class="popBox_payStyle_wei_left">
                <img
                  src="@/assets/images/setting/weixin.png"
                  v-if="item.method_name == '微信支付'"
                />
                <img src="@/assets/images/setting/zhifu.png" v-else />
                <p>{{ item.method_name }}</p>
              </div>
              <div class="popBox_payStyle_wei_right">
                <van-radio :name="JSON.stringify(index)"></van-radio>
              </div>
            </div>
          </van-radio-group>
        </div>
        <van-button
          class="popBox_button"
          @click="pay"
          :loading="btnLoading"
          loading-text="支付唤起中"
        >
          立即支付￥{{ orderDetail.price }}
        </van-button>
      </div>
    </van-popup>
    <div id="zhifuB"></div>
  </div>
</template>
<script>
import dialogCommon from "@/components/dialogCommon";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import { setOpenId, registerWxConfig } from "@/weixinConfig";
import {
  _orderDetail,
  _addressList,
  _createOrder,
  _paymentMethodList,
  _payOrder,
  _exsitUnpaidOrders,
} from "../../api/setting";
import wx from "weixin-js-sdk";
export default {
  name: "orderConfirm",
  data() {
    return {
      adreess: {}, //地址数据
      show: false, //未填地址 弹窗 标识
      infoMsg: "", //未填地址 弹窗 内容
      sureMsg: "", //右边按钮 弹窗 按钮文字
      cancelMsg: "", //左边按钮 弹窗 按钮文字
      popShow: false, //支付方式弹窗标识
      radio: "0", //支付方式标识
      orderDetail: {}, //订单数据
      id: "", //订单id(可能用不上)
      totalAmount: 0, //下单总金额（商品价格和邮费）
      loading: false, //loading标识
      payTypeList: [], //支付方式列表
      btnLoading: false,
    };
  },
  components: {
    dialogCommon,
  },
  created() {
    if (!sessionStorage.getItem("openid")) {
      registerWxConfig();
    }
    // if (!sessionStorage.getItem("openid")) {
    //   setOpenId("1");
    // }
    // this.id = this.$route.query.id;
    // this.getOrderDetail();
    this.orderDetail = JSON.parse(sessionStorage.getItem("orderDetails"));
    this.orderDetail.price = this.orderDetail.price
      ? this.orderDetail.price
      : 0;
    this.orderDetail.postPrice = this.orderDetail.postPrice
      ? this.orderDetail.postPrice
      : 0;
    this.totalAmount = Number(
      this.orderDetail.price + this.orderDetail.postPrice
    );

    let address = localStorage.getItem("adress"); //进入这个页面的所有入口需要 在localStorage存adress为空（除了地址列表页）
    if (address) {
      //如果是从地址列表页修改地址回来 需要替换地址 否则 其他入口直接取默认地址
      address = JSON.parse(address);
      this.adreess = address;
      console.log(this.adreess, "88888888");
    } else {
      this.addressList();
    }
  },
  mounted() {},
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getDecryptBy(val) {
      if (val) {
        return decryptBy(val);
      }
    },
    getAdreess(val) {
      if (val) {
        return Object.keys(val).length == 0;
      }
    },
    // 获取订单详情
    getOrderDetail() {
      _orderDetail({
        orderId: this.id,
      }).then((res) => {
        if (res && res.code == 200) {
          this.orderDetail = res.data;
          this.orderDetail.price = this.orderDetail.price
            ? this.orderDetail.price
            : 0;
          this.orderDetail.postPrice = this.orderDetail.postPrice
            ? this.orderDetail.postPrice
            : 0;
          this.totalAmount = Number(
            this.orderDetail.price + this.orderDetail.postPrice
          );
        }
      });
    },
    // 获取收货地址列表
    addressList() {
      this.loading = true;
      _addressList()
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data && res.data.length > 0) {
              this.adreess = res.data[0];
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //创建订单
    createOrder(val) {
      this.loading = true;
      console.log(val, "订单信息");
      _createOrder(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              this.orderDetailId = res.data.id;
              this.loading = false;
              this.getPaymentMethodList();
            }
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //跳转地址列表页
    goAdressList() {
      this.$router.push({
        path: "/adressList",
      });
    },
    //跳转添加地址页面
    goAdress(item) {
      if (item == 1) {
        this.$router.push({
          path: "/addAdress",
        });
      } else {
        this.gocreateOrder();
      }
      this.show = false;
    },
    gocance(item) {
      if (item == 2) {
        this.$router.push({
          path: "/myOrder",
        });
      }
      this.show = false;
    },
    //点击立即支付 需创建订单
    submit() {
      console.log(
        this.orderDetail,
        this.adreess,
        this.getAdreess(this.adreess)
      );
      if (this.orderDetail.isPost && this.getAdreess(this.adreess)) {
        this.infoMsg = "未添加收获地址，请确认添加后，再进行购买"; //未填地址 弹窗 内容
        this.sureMsg = "添加收获地址"; //未填地址 弹窗 按钮文字
        this.show = true;
      } else {
        let params = {
          productId: this.orderDetail.id,
        };
        _exsitUnpaidOrders(params).then((res) => {
          if (res.data) {
            this.infoMsg = "您有未支付的订单"; //未填地址 弹窗 内容
            this.sureMsg = "提交订单"; //未填地址 弹窗 按钮文字
            this.cancelMsg = "查看订单"; //弹窗按钮显示
            this.show = true;
          } else {
            this.gocreateOrder();
          }
        });
      }
    },
    gocreateOrder() {
      let param = {};
      // param.price = this.totalAmount;
      // param.postAddress = this.orderDetail.postAddress;
      // param.postAddressId = this.orderDetail.postAddressId;
      // param.postPrice = this.orderDetail.postPrice;
      // param.productCode = this.orderDetail.productCode;
      // param.productId = this.orderDetail.productId;
      // param.productName = this.orderDetail.productName;
      // param.recipientName = this.orderDetail.recipientName;
      // param.productType = this.orderDetail.productType;
      // param.recipientTel = this.orderDetail.recipientTel;
      // param.userId = this.orderDetail.userId;
      // param.userName = this.orderDetail.userName;
      param.originalPrice = this.orderDetail.price;
      param.payTypeId = "";
      param.payTypeName = "";
      param.postPrice = this.orderDetail.postPrice;
      param.productCode = "";
      param.productId = this.orderDetail.id;
      param.productName = this.orderDetail.title;
      param.productType = this.orderDetail.isCourse == 0 ? 1 : 2;
      if (this.orderDetail.isPost) {
        param.postAddress =
          this.adreess.province +
          this.adreess.city +
          this.adreess.county +
          this.adreess.address;
        param.postAddressId = this.adreess.id;
        param.recipientName = this.adreess.contacts;
        param.recipientTel = this.adreess.phone;
      } else {
        param.postAddress = "";
        param.postAddressId = "";
        param.recipientName = "";
        param.recipientTel = "";
      }

      param.userId = "";
      param.userName = "";

      this.createOrder(param);
    },
    // 获取支付方式
    getPaymentMethodList() {
      _paymentMethodList({
        clientType: "wap",
      }).then((res) => {
        if (res && res.statusCode == 200) {
          res.data = res.data.slice(0, 2);

          this.payTypeList = res.data;
          if (res.data && res.data.length > 0) {
            //调起选择支付模式弹窗
            this.popShow = true;
          }
        }
      });
    },
    //关闭弹窗
    close() {
      this.show = false;
    },
    //支付
    pay() {
      this.btnLoading = true;
      if (this.radio == "0") {
        registerWxConfig();
        //radio为 0==微信   1==支付宝
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 1,
          openid,
          order_price: this.orderDetail.price,
          order_sn: this.orderDetailId,
          system_id: 1,
        };
        _payOrder(params)
          .then((res) => {
            if (res.code == 200) {
              res.data = JSON.parse(res.data);
              wx.chooseWXPay({
                timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                paySign: res.data.paySign, // 支付签名
                success: function (res) {
                  console.log("支付成功了", res);
                  // 支付成功后的回调函数
                  window.location.href = "/#/paymentCallbackJump";
                },
                fail: function (error) {
                  console.log("error", error);
                  window.location.href = "/#/paymentCallbackJump";
                },
              });
            } else {
              Toast(res.message);
            }
            this.btnLoading = false;
          })
          .catch((res) => {
            Toast(res.message);
            this.btnLoading = false;
          });
      } else {
        this.btnLoading = true;
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 2,
          openid,
          order_price: this.orderDetail.price,
          order_sn: this.orderDetailId,
          system_id: 2,
        };
        _payOrder(params)
          .then((res) => {
            if (res.code == 200) {
              const div = document.getElementById("zhifuB");
              div.innerHTML = res.data;
              div.getElementsByTagName("form")[0].submit();
            } else {
              Toast(res.message);
            }
            this.btnLoading = false;
          })
          .finally((res) => {
            Toast(res.message);
            this.btnLoading = false;
          });
      }
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.orderConfirm {
  height: 100%;
  background: #f5f7fa;
  .orderConfirm_content {
    padding-top: 48px;
    position: relative;
    height: 100%;
    .myOrderDetail_content_fix {
      position: fixed;
      width: 375px;
      height: 49px;
      background: #edeff2;
      display: flex;
      bottom: 0;
      justify-content: space-between;
      align-items: center;
      .myOrderDetail_content_fix_left {
        margin-left: 20px;
        display: flex;
        align-items: center;
        p {
          font-size: 26px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #ee3721;
          span {
            font-size: 18px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #ee3721;
          }
        }
        .myOrderDetail_content_fix_left_left {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
          margin-top: 5px;
          margin-right: 9px;
        }
      }
      .myOrderDetail_content_fix_right {
        width: 141px;
        height: 40px;
        background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
        border-radius: 22px;
        margin-right: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .myOrderDetail_content_noAddress {
      width: 375px;
      background: #ffffff;
      .myOrderDetail_content_noAddress_cont {
        display: flex;
        justify-content: space-between;
        padding: 38px 0;
        .myOrderDetail_content_noAddress_cont_left {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-right: 10px;
            margin-left: 20px;
          }
          div {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #949c9d;
          }
        }
        .myOrderDetail_content_noAddress_cont_right {
          width: 22px;
          height: 22px;
          margin-right: 30px;
        }
      }
      .myOrderDetail_content_address_bottom {
        display: block;
        width: 100%;
      }
    }
    .myOrderDetail_content_address {
      width: 375px;
      background: #ffffff;
      .myOrderDetail_content_address_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        padding-top: 10px;
        margin-left: 10px;
        .myOrderDetail_content_address_top_left {
          display: flex;
          align-items: center;
        }

        img {
          width: 22px;
        }
        .myOrderDetail_content_address_top_name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
          margin-left: 8px;
          margin-right: 16px;
        }
        .myOrderDetail_content_address_top_phone {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
        }
        .myOrderDetail_content_address_top_right {
          width: 32px;
          height: 20px;
          background: #fcd7d3;
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ee3721;
          text-align: center;
          line-height: 20px;
          margin-left: 15px;
        }
      }
      .myOrderDetail_content_address_contentBox {
        display: flex;
        justify-content: space-between;
        .myOrderDetail_content_address_content {
          width: 256px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #626a6b;
          margin-left: 40px;
          margin-top: 8px;
          margin-bottom: 14px;
        }
        img {
          width: 22px;
          height: 22px;
          margin-right: 30px;
          margin-top: 7px;
        }
      }

      .myOrderDetail_content_address_bottom {
        display: block;
        width: 100%;
      }
    }
    .myOrderDetail_content_bot {
      padding: 12px 21px 15px 21px;
      width: 375px;
      background: #ffffff;
      margin: 8px 0;
      .myOrderDetail_content_bot_top {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e4344;
        margin-bottom: 12px;
      }
      .myOrderDetail_content_bot_cen {
        display: flex;
        .myOrderDetail_content_bot_cen_img {
          width: 128px;
          height: 72px;
          border-radius: 4px;
          margin-right: 12px;
        }
        .myOrderDetail_content_bot_cen_rig {
          .myOrderDetail_content_bot_cen_rig_title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2e4344;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-top: 4px;
          }
          .myOrderDetail_content_bot_cen_rig_biaoqian {
            display: inline-block;
            height: 22px;
            background: rgba(250, 125, 0, 0.1);
            border-radius: 11px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fa7d00;
            line-height: 22px;
            text-align: center;
            padding: 0 8px;
            margin-top: 4px;
          }
        }
      }
      .myOrderDetail_content_bot_pay,
      .myOrderDetail_content_bot_pay1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #949c9d;
        }
        .myOrderDetail_content_bot_pay_way {
          display: flex;
          align-items: center;
          p {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2e4344;
          }
        }
        .myOrderDetail_content_bot_pay_money,
        .myOrderDetail_content_bot_pay_money1 {
          font-size: 20px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #626a6b;
          span {
            font-size: 14px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #626a6b;
          }
        }
      }
      .myOrderDetail_content_bot_pay1 {
        margin-top: 24px;
        p {
          font-size: 14px;
          color: #2e4344;
        }
        .myOrderDetail_content_bot_pay_money {
          font-size: 26px;
          color: #ee3721;
          span {
            font-size: 18px;
            color: #ee3721;
          }
        }
      }
    }
  }
  .popBox_price {
    font-size: 32px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ee3721;
    text-align: center;
    margin-top: 19px;
    span {
      font-size: 24px;
    }
  }
  .popBox_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #484848;
    margin-top: 20px;
    margin-left: 20px;
  }
  .popBox_payStyle_wei {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    .popBox_payStyle_wei_left {
      display: flex;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
        margin-left: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #484848;
      }
    }
    .popBox_payStyle_wei_right {
      margin-right: 40px;
    }
  }
  .popBox_button {
    width: 300px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 37.5px;
    margin-top: 56px;
  }
}
</style>
